import React from "react";
import { MessageCircle } from "lucide-react";
import { motion } from "framer-motion";
import { useLang } from "@/context/LangContext";
import { openWhatsApp } from "@/lib/wa";

// Mobile-first floating WhatsApp order button for maximum conversion.
export default function FloatingWhatsApp() {
  const { t } = useLang();
  return (
    <motion.button
      initial={{ scale: 0, opacity: 0 }}
      animate={{ scale: 1, opacity: 1 }}
      transition={{ delay: 2, type: "spring", stiffness: 200 }}
      onClick={() => openWhatsApp(t.waOrder)}
      data-testid="floating-whatsapp"
      className="fixed bottom-5 right-5 z-40 flex items-center gap-2 rounded-full bg-[#25D366] px-5 py-4 font-sans text-sm font-semibold text-black shadow-lg shadow-black/40 transition-transform hover:scale-105"
      aria-label="WhatsApp"
    >
      <MessageCircle size={20} />
      <span className="hidden sm:inline">WhatsApp</span>
    </motion.button>
  );
}
